import React, { useEffect, useRef, useState } from 'react'
import { Divider } from 'primereact/divider'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import imagineHomeService from './imagineHomeService'
import { Messages } from 'primereact/messages'
import { delay } from '../../utilities/utillFunction'
import { assignment_status_color } from '../../utilities/constant'

const inputStyle = {
    borderRadius: "1.25rem",
    border: "1px solid rgba(116, 120, 141, 0.20)",
    background: "#FAFAFA"
}
const InvoiceDetails = ({ receivedData = {}, back }) => {
    const [data, setData] = useState(receivedData["body"] ?? {})
    const messages = useRef()
    const [errMsgs, setErrMsgs] = useState({})

    useEffect(()=> {
        if(data) {
            const calcFinalAmt = Number((data.sub_total ?? 0)) + Number((data.tax_amount ?? 0)) - Number((data.discount_amount ?? 0))
            const calcbalanceDue = Number((data.hs_amount_billed ?? 0)) - Number((data.paid_amount ?? 0))
            const msg =  {}
            if(differenceCondition(calcFinalAmt, data.hs_amount_billed ?? 0)) msg["totalAmountMsg"] = "Total Amount Mismatch"
            if(differenceCondition(calcbalanceDue, data.balance_due ?? 0)) msg["balanceDueMsg"] = "BALANCE DUE MISMATCH"
            setErrMsgs(msg)
        }
        function differenceCondition (value1, value2) {
            const difference = Number(value1) - Number(value2)
            return difference >= 1 || difference <= -1
        }
    },[data])

    useEffect(()=> {
        if(data) {
            let newdata = JSON.parse(JSON.stringify(data))
            if(!data.hs_amount_billed) {
                const newFinalAmt = Number((data.sub_total ?? 0)) + Number((data.tax_amount ?? 0)) - Number((data.discount_amount ?? 0))
                newdata.hs_amount_billed = showValue(newFinalAmt)
            }
            if(!data.balance_due) {
                const new_balance_due = Number(newdata.hs_amount_billed ?? 0) - Number(data.paid_amount ?? 0)
                newdata.balance_due = showValue(new_balance_due)
            }
            newdata['sub_total'] = showValue(newdata['sub_total'])
            newdata['discount_amount'] = showValue(newdata['discount_amount'])
            newdata['tax_amount'] = showValue(newdata['tax_amount'])
            newdata['hs_amount_billed'] = showValue(newdata['hs_amount_billed'])
            newdata['balance_due'] = showValue(newdata['balance_due'])
            newdata['paid_amount'] = showValue(newdata['paid_amount'])
            setData(newdata)
        }
    },[])

    const handleChange = (e, key, value, isItem, id) => {
        let newdata = JSON.parse(JSON.stringify(data))
        if (isItem) {
            if (key === 'quantity' && isNaN(value)) return
            newdata['items'][id][key] = key === 'quantity' ? Number(value) : value
        }
        else {
            if (isNaN(value)) return
            newdata[key] = value
        }
        setData(newdata)
    }

    const showValue = (value = 0) => {
        if(!value) return 0
        value = Number(value)
        return Number(value.toFixed(2))
    }

    const handleSubmit = () => {
        const payload = receivedData
        //data['hs_amount_billed'] = parseFloat(data['hs_amount_billed'])
        //temporary change roll back to upper commentted code
        data['hs_amount_billed'] = parseFloat(data['balance_due'])
        data['balance_due'] = parseFloat(data['balance_due'])
        data['sub_total'] = parseFloat(data['sub_total'])
        data['tax_amount'] = parseFloat(data['tax_amount'])
        data['discount_amount'] = parseFloat(data['discount_amount'])
        data['paid_amount'] = parseFloat(data['paid_amount'])
        payload["body"] = data
        imagineHomeService.saveInvoiceData(payload).then(async (res) => {
            if(res) {
                messages.current.show([{ severity: 'success', summary: '', detail: " Invoice Data Saved" }]);
                await delay(2000)
                back()
            }
            else messages.current.show([{ severity: 'error', summary: '', detail: " Error Saving data", sticky: true }]);

        }).catch((err) => {
            console.log(err)
            messages.current.show([{ severity: 'error', summary: 'Error', detail: err.detail }]);
        })
    }

    return (
        <>
            <div className='flex justify-content-between mb-3'>
                <div className='flex align-items-center color3' style={{ gap: 10, fontFamily: "Inter" }}>
                    <img onClick={() => back()} src='/images/Back.svg' className='cursor-pointer' />
                    <h2 className='m-0 font-light font-larken text-4xl white-space-nowrap'>Invoice Details</h2>
                </div>
                <div className='flex flex-column  align-items-start color3' style={{ gap: 10, fontFamily: "Inter" }}>
                    <span>Invoice number: <span className='font-bold'>{data.hs_number}</span></span>
                    <span>Invoice date: <span className='font-bold'>{data.invoice_date}</span></span>
                </div>
            </div>
            <Divider style={{ backgroundColor: "#9AAB89", height: "1px" }} />
            <div>
                {(data.items && data.items.length) ?
                    data.items.map((item, idx) => {
                        return <div key={idx}>
                            <p className='font-larken m-0 font-light text-2xl color-charcoal'>{`Item ${idx + 1}`}</p>
                            <div className='col-12 flex p-0'>
                                <div className='col-3 pl-0'>
                                    <p className='text-base mb-2 color-charcoal font-larken' style={{ fontWeight: 100 }}>ITEM</p>
                                    <span className='color3 font-medium text-sm'>{item.itemName}</span>
                                </div>
                                <div className='col-3'>
                                    <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>SKU</p>
                                    <InputText style={inputStyle} value={item.sku} onChange={(e) => handleChange(e, 'sku', e.target.value, true, idx)} className='w-11' />
                                </div>
                                <div className='col-3'>
                                    <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Quantity</p>
                                    <InputText style={inputStyle} inputMode='numeric' pattern='[0-9\s]{13,19}' value={item.quantity} onChange={(e) => handleChange(e, 'quantity', e.target.value, true, idx)} className='w-11' />
                                </div>
                                <div className='col-3'>
                                    <p className='text-base mb-2 color-charcoal font-larken' style={{ fontWeight: 100 }}>Price</p>
                                    <span className='color3 font-medium text-sm'>${showValue(item.price)}</span>
                                </div>
                            </div>
                            <Divider type='dashed' />
                        </div>
                    }) : <p className='text-2xl color3 font-larken text-center'>No Items in invoice </p>}
                <p className='font-larken m-0 font-light text-2xl color-charcoal'>Total Bill</p>
                <div className='col-12 flex p-0'>
                    <div className='col-3 pl-0'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Sub Total</p>
                        $<InputText style={inputStyle} value={data.sub_total ?? 0} onChange={(e) => handleChange(e, 'sub_total', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Total Discount</p>
                        $<InputText style={inputStyle} value={data.discount_amount ?? 0} onChange={(e) => handleChange(e, 'discount_amount', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Tax</p>
                        $<InputText style={inputStyle} value={data.tax_amount ?? 0} onChange={(e) => handleChange(e, 'tax_amount', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3 flex align-items-center justify-content-center mt-4'>
                        {errMsgs['totalAmountMsg'] && <span className='status-badge my-auto' style={assignment_status_color['SubmittedForReview']}>{errMsgs['totalAmountMsg']}</span>}
                    </div>
                </div>
                <div className='col-12 flex p-0'>
                    <div className='col-3 pl-0'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Total</p>
                        $<InputText style={{...inputStyle, ...{borderWidth:"1px", borderColor: "#47422F"}}} value={data.hs_amount_billed ?? 0} onChange={(e) => handleChange(e, 'hs_amount_billed', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Amount Paid</p>
                        $<InputText style={inputStyle} value={data.paid_amount ?? 0} onChange={(e) => handleChange(e, 'paid_amount', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3'>
                        <p className='text-base m-0 color-charcoal font-larken' style={{ fontWeight: 100 }}>Balance Due</p>
                        $<InputText style={{...inputStyle, ...{borderWidth:"1px", borderColor: "#9AAB89"}}} value={data.balance_due ?? 0} onChange={(e) => handleChange(e, 'balance_due', e.target.value, false)} className='w-11' />
                    </div>
                    <div className='col-3 flex align-items-center justify-content-center mt-4'>
                        {errMsgs['balanceDueMsg'] && <span className='status-badge my-auto' style={assignment_status_color['SubmittedForReview']}>{errMsgs['balanceDueMsg']}</span>}
                    </div>
                </div>
            </div>
            <Divider style={{ backgroundColor: "#9AAB89", height: "1px" }} />
            <div className='flex justify-content-end'>
                <Messages className='invoice-msg' style={{fontSize:"1rem"}} ref={messages} />
                <Button label='CANCEL' className='px-4 mr-3 p-button-rounded p-button-outlined text-sm' onClick={() => back()} style={{ color: "#9AAB89", background: "#FBF9F3", letterSpacing: "1.44px" }}></Button>
                <Button label='SUBMIT' className='px-4 p-button-rounded p-button-outlined text-sm' disabled={Object.keys(errMsgs).length} onClick={handleSubmit} style={{ background: "#47422F", color: "#FBF9F3", letterSpacing: "1.44px" }}></Button>
            </div>
        </>
    )
}

export default InvoiceDetails